import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';
import { FaSave, FaAngleLeft, FaCalendarAlt, FaTimes, FaPlus, FaCircle, FaArrowCircleRight  } from "react-icons/fa";
import { Formik } from "formik";
import * as yup from "yup";
import { API } from 'aws-amplify';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'react-moment';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Map from '../../../components/Map/Map';
import '../Device.css';

import { useToasts } from 'react-toast-notifications';
import DevicePerms from './DevicePerms';
import DeviceDocs from './DeviceDocs';

const headers = {
    'x-api-key': process.env.REACT_APP_API_KEY,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    }

const params = {
    headers: headers,
}

const arrow_icon_url = "https://earth.google.com/images/kml-icons/track-directional/track-0.png";

// Function to offset the arrow based on rotation (0° = down)
function getArrowOffset(rotation, distance = 20) {
    // 0° is down, positive is clockwise
    const rad = (rotation - 90) * Math.PI / 180;
    const x = Math.cos(rad) * distance;
    const y = Math.sin(rad) * distance;
    return { x, y };
}

async function addMarkers(map, links) {
    // Import the marker library
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
  
    let infoWindow;
    const markers = [];
  
    links.forEach((link) => {
        // Create a container div for pin + arrow
        const container = document.createElement("div");
        container.style.position = "relative";
        container.style.display = "flex";
        container.style.flexDirection = "column";
        container.style.alignItems = "center";

        // Arrow image (rotated, only if rotation is set and not zero)
        if (typeof link.rotation === 'number') {
            const arrow = document.createElement("img");
            arrow.src = link.arrowIcon;
            arrow.style.width = "36px";
            arrow.style.height = "36px";
            arrow.style.transform = `rotate(${link.rotation}deg)`;
            arrow.style.transformOrigin = "50% 50%";
            arrow.style.position = "absolute";
            arrow.style.zIndex = "1";
            // Offset arrow based on direction
            const offset = getArrowOffset(link.rotation, 34); // 24px distance, adjust as needed
            arrow.style.left = `calc(50% + ${offset.x}px - 18px)`; // 18px = half arrow width
            arrow.style.top = `calc(50% + ${offset.y}px - 18px)`;
            container.appendChild(arrow);
        }

        // Pin image (not rotated)
        const pin = document.createElement("img");
        pin.src = link.icon;
        pin.style.width = "32px";
        pin.style.height = "32px";
        pin.style.position = "relative";
        pin.style.zIndex = "2";
        container.appendChild(pin);

        const marker = new AdvancedMarkerElement({
            map,
            position: link.coords,
            title: link.title,
            content: container,
        });
  
        marker.addListener("click", () => {
            if (infoWindow) {
                infoWindow.close();
            }
  
            infoWindow = new window.google.maps.InfoWindow({
                content: link.content,
            });
    
            infoWindow.open(map, marker);
        });
  
        markers.push({
            id: link.id,
            marker: marker,
        });

    });
  
    return markers;
}

const DeviceDetail = (props) => {
    const { addToast } = useToasts();
    const [inst_date, setInst_date] = useState('');
    const [expiry_date, setExp_date] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [isAssetEdit, setAssetEdit] = useState(false);
	// const [locationList, setLocationList] = useState([]);
	// const [countryList, setCountryList] = useState([]);
	const [sites, setSites] = useState([]);
	const [site, setSite] = useState({});
	const [userUpd, setUserUpd] = useState([]);
    // const [locationAll, setLocationAll] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const [mapAsset, setMapAsset] = useState([]);
    const [viewMapAssets, setViewMapAssets] = useState([]);

    // Same Site Assets = SSAssets
    const [mapSSAssets, setMapSSAssets] = useState([]);
    const [SSAssets, setSSAssets] = useState([]);

    const [asset, setAsset] = useState({id: null,
                                        name: '',
                                        make: '',
                                        address: '',
                                        serial_number: '',
                                        sim_card: '',
                                        firmware: '',
                                        location: '',
                                        latitude: '',
                                        longitude: '',
                                        additional_info: '',
                                        inst_date: '',
                                        expiry_date: '',
                                        vpn: '',
                                        status: 'active',
                                        date_created: new Date().toISOString(),
                                        zones: [],
                                        relays: [],
                                        emails: [],
                                        mqtt_chk: false,
                                        mqtt: {
                                            mqtt_server: 'mqtt.ipsum365.com',
                                            topic: [],
                                            subscribe: false
                                        },
                                        email: '',
                                        send_email: false,
                                        email_sent: false,
                                        email_sent_date: '',
                                        topic: '',
                                        site_id: '',
                                        airscan_id: '',
                                        speed: '',
                                        img: null,
                                        message: '',
                                        rotation: 0
                                    });

    const pin_green = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
    const pin_yellow = "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";

    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy']
    }

    const [sliderRotation, setSliderRotation] = useState(0); // For live preview

    // Load asset
    useEffect(()=>{
        if (props.match.params.id){
            setLoading(true);
            API.get('asset','/' + props.match.params.id, params)
            .then(res => {

                if (typeof res !== 'object' || res === null) {
                    res = {}; // Force it to be an object
                }

                if (res.inst_date === undefined)
                    res.inst_date = ''
                else
                    setInst_date(new Date(res.inst_date))

                if (res.expiry_date === undefined)
                    res.expiry_date = ''
                else
                    setExp_date(new Date(res.expiry_date))

                if (res.zones === undefined ) {
                    res.zones = [];
                    for (let i = 0; i < 26; i++) {
                        res.zones.push({id: 'Zone ' + i, label: ''})
                    }
                } else {
                    for (let i = 0; i < 26; i++) {
                        if (res.zones[i]) {
                            res.zones[i].id = res.zones[i].id || '';
                            res.zones[i].label = res.zones[i].label || '';
                        }else{
                            res.zones.push({id: 'Zone ' + i, label: ''})
                        }
                    }
                }

                if (res.relays === undefined ) {
                    res.relays = [];
                    for (let i = 0; i < 16; i++) {
                        res.relays.push({id: ['R',i+1].join(''), label: ''})
                    }
                } else {
                    for (let i = 0; i < 16; i++) {
                        if (res.relays[i]) {
                            res.relays[i].id = res.relays[i].id || '';
                            res.relays[i].label = res.relays[i].label || '';
                        }else{
                            res.relays.push({id: ['R',i+1].join(''), label: ''})
                        }
                    }
                }

                if (res.emails === undefined ) res.emails = [];
                if (res.email === undefined ) res.email = '';
                if (res.send_email === undefined ) res.send_email = false;
                if (res.email_sent === undefined ) res.email_sent = false;
                if (res.email_sent_date === undefined ) res.email_sent_date = '';


                if (res.mqtt === undefined){
                    // const ref = res.id.split('-')
                    res.mqtt = {
                        mqtt_server: 'mqtt.ipsum365.com',
                        // topic: ref[0] + '/traffic-statistic-output/sensor1',
                        topic: [],
                        subscribe: false
                    }
                }
                if (res.mqtt_chk === undefined)
                    res.mqtt_chk = false

                if (res.status === undefined)
                    res.status = 'active'

                if (res.airscan_id === undefined)
                    res.airscan_id = ''

                if (res.speed === undefined)
                    res.speed = 'kph'

                if (res.img === undefined)
                    res.img = null

                if (res.rotation === undefined)
                    res.rotation = 0

                res.topic =''

                setAsset(res);
                setLoading(false);
                setAssetEdit(true);
            });
        }else{
            setLoading(true);
            asset.zones = [];
            for (let i = 0; i < 26; i++) {
                asset.zones.push({id: 'Zone ' + i, label: ''})
            }
            asset.relays = [];
            for (let i = 0; i < 16; i++) {
                asset.relays.push({id: ['Relay ', i+1].join(''), label: ''})
            }
            asset.topic =''


            asset.site_id = props.match.params.sid || undefined
            // if (sites.length>0 && asset.site_id !== undefined) handleSite(asset.site_id)
            
            setAsset(asset);
            setLoading(false);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.id, props.match.params.sid]); //locationAll

    // Load sites
	useEffect(()=>{
		const fetchSites = async () => {

            // let assets = await API.get('asset','/', params)
            // assets = assets.sort((a, b) => (a.name > b.name) ? 1 : -1)

            // //Get user asset list
            // // let user_assets = []
            // // user_assets = await API.get('user_assets','/' + props.user.username, params)
            // let user_assets = props.user.user_assets || []

            // let assetsFiltered = []
            // if (user_assets){
            //     // user_assets = user_assets.assets;
            //     assetsFiltered = assets.filter(x => user_assets.find(i => i === x.id)).map(i => i.site_id);
            // }

            // if (assetsFiltered.length > 0){
                let data = await API.get('sites','/', params)
                data = data.sort((a, b) => (a.name > b.name) ? 1 : -1).filter(item => item.active === true)
                data = data.map(item => {
                    let stat = 'text-success';
                    switch (item.status) {
                        case 'active': 
                        stat = 'text-success'; 
                        break;
                        case 'inactive': 
                        stat = 'text-secondary'; 
                        break;      
                        case 'removed': 
                        stat = 'text-danger'; 
                        break;  
                        default:
                        stat = 'text-success'; 
                    }
                    
                    return {...item, 
                    statusCss: stat
                    }})

                // if  (props.user.administrator==='false')
                //     data = data.filter(item => assetsFiltered.find(x => x === item.id))

                setSites(data);
                setSite(data.find(x => x.id === asset.site_id))
            // }  
        }  

        if (asset.site_id !== undefined && asset.site_id !== '')
            fetchSites();

    }, [asset]);

    // Load Same Site Assets - SSAssets
    useEffect(()=>{
        const fetchSSAssets = async () => {
            let data = await API.get('site_assets','/' + asset.site_id, params)

            // Give some status color like in site detail
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                let stat = 'text-success';
                switch (item.status) {
                    case 'active': 
                    stat = 'text-success'; 
                    break;
                    case 'inactive': 
                    stat = 'text-secondary'; 
                    break;      
                    case 'removed': 
                    stat = 'text-danger'; 
                    break;  
                    default:
                    stat = 'text-success'; 
                }
                item.statusCss = stat;
            }

            // Remove the current asset from the list
            setSSAssets(data.filter(item => item.id !== asset.id));
        }  

        if (asset.site_id !== undefined && asset.site_id !== '')
            fetchSSAssets();

    }, [asset]);

    // Load Map Asset
    useEffect(()=>{
        if (asset.id !== undefined && asset.site_id !== '')
            setMapAsset([createMapLink(asset, "asset")])

    }, [asset]);

    // Load Map SSAssets
    useEffect(()=>{
        const addMapSSAssets = () => {
            setMapSSAssets([]);
            SSAssets.forEach(item => {
                if (item.id !== undefined && item.site_id !== '')
                    setMapSSAssets(sites => [...sites, createMapLink(item, "SSA")]);
            })
        }

        if (SSAssets.length > 0)
            addMapSSAssets();

    }, [SSAssets]);

    // Load View Map Assets
    useEffect(()=>{
        if (asset.id != undefined && asset.id != "" && SSAssets.length > 0) {
            setViewMapAssets([...mapAsset, ...mapSSAssets]);
        } else if (asset.id != undefined && asset.id != "") {
            setViewMapAssets([...mapAsset]);
        }

    }, [mapAsset, mapSSAssets]);

    useEffect(() => {
        setSliderRotation(asset.rotation || 0);
    }, [asset.rotation]);

    // Store marker references for external access
    const markerRefs = React.useRef({});

    const createMapLink = (assetProp, type) => {
        let icon = pin_green;
        let headerContent;
        if (type === "asset") {
            headerContent = 
                '<span class="map-dev">' +
                    `<p class="text-primary" id="marker-link-${assetProp.id}">${assetProp.name}</p>` +
                '</span>';
            icon = pin_green;
        } else if (type === "SSA") {
            headerContent = 
                '<span class="map-dev">' +
                    `<a href="/device_det/${assetProp.id}" class="text-primary" id="marker-link-${assetProp.id}">${assetProp.name}</a>` +
                '</span><br><br>';
            icon = pin_yellow;
        } 

        let lat = 0;
        let long = 0;
        if (assetProp.latitude) {
            lat = parseFloat(assetProp.latitude)
        }
        if (assetProp.longitude){
            long = parseFloat(assetProp.longitude)
        }
        
        let last_upd = 'Not Available'
        if (assetProp.last_update){
            last_upd = '<span class="text-dark">'+ moment.utc(new Date(assetProp.last_update)).local().format(formatDate[1]) +'</span>';
        }

        // create marker content
        const link = {
            id: assetProp.id,
            coords: { lat: +lat, lng: +long },
            icon: icon, // Use image URL for pin
            arrowIcon: arrow_icon_url, // Use default arrow image
            rotation: assetProp.rotation || 0, // Pass rotation for arrow
            content:'<div class="map-div">' +
            headerContent +
            '<span class="text-dark"><strong>'+ assetProp.location  +'</strong></span><br/>' +
            '<span class="text-dark">'+ assetProp.address + ' - ' + last_upd +'</span><br/><br/>' +
            '<span class="text-secondary small">Location: '+ assetProp.latitude  +', '+ assetProp.longitude +'</span><br/>' +
            '</div>'
        }
        return link;
    }
    
    // Add initial coordinates and zoom to the map, it will re-center and resize when it finishes loading assets
    const mapProps = {
        options: { center: { lat: parseFloat(process.env.REACT_APP_MAP_LAT), lng: parseFloat(process.env.REACT_APP_MAP_LNG) }, zoom: 12, scrollwheel: true, mapId: "de70c7e1386f9fba" },

        onMount: async (map, links) => {
            // Use the original addMarkers function
            const markers = await addMarkers(map, links);

            // Store marker references by id for external activation
            markerRefs.current = {};
            markers.forEach(({ id, marker }) => {
                markerRefs.current[id] = marker;
            });
        },
        onMountProps: viewMapAssets,
        className: 'gmaps-asset',
    }

    // Function to activate marker popup externally
    const activateMapMarker = (id) => {
        const marker = markerRefs.current[id];
        if (marker) {
            window.google.maps.event.trigger(marker, 'click');
        }
    };

    // Reload the map only when necessary
    const MemoMap = useCallback(<Map {...mapProps} />, [mapProps])
    
    const restartGPS = () => {
        setAsset({
            ...asset,
            latitude: site.latitude,
            longitude: site.longitude
        });
    }

    const handleSubmit = async (data) => {
        //Edit task
        if (asset.id !== null){
            data.id = asset.id
            // edit user_asset permissions
            // console.log(userUpd)

            userUpd.forEach(async ({username, checked, action}) =>{
                if (action==="add"){
                    // console.log("add ",checked, username)
                    const user_assets = await API.get('user_assets','/' + username, params)
                    API.post('user_assets', '/', {
                        body: {
                            id: user_assets.id,
                            assets: [...user_assets.assets, data.id],
                            views: user_assets.views,
                            settings: user_assets.settings
                        },
                        headers,
                    }); 
                }
                if (action==="rem"){
                    // console.log("rem ",checked, username)
                    const user_assets = await API.get('user_assets','/' + username, params)
                    API.post('user_assets', '/', {
                        body: {
                            id: user_assets.id,
                            assets: user_assets.assets.filter(item => item !== data.id),
                            views: user_assets.views,
                            settings: user_assets.settings
                        },
                        headers,
                    }); 
                }
            })

       }else{
            data.id = data.serial_number

            // add new asset to user access list
            const user_assets = await API.get('user_assets','/' + props.user.username, params)
            API.post('user_assets', '/', {
                body: {
                    id: user_assets.id,
                    assets: [...user_assets.assets, data.id],
                    views: user_assets.views,
                    settings: user_assets.settings
                },
                headers,
            });       
       }

       data.mqtt.topic = asset.mqtt.topic
       if (data.mqtt.topic && data.mqtt.topic.length > 0)
           data.mqtt.subscribe = true;
       else
           data.mqtt.subscribe = false;
       data.mqtt_chk = asset.mqtt_chk

       data.emails = asset.emails;
       data.email = '';
       data.topic ='';

       if (site){
        // console.log("SITE >>",site)
        // data.site_id = site.id
        data.address = site.address;
        data.country = site.country;
        data.location = site.location;
        if (!isAssetEdit) {
            data.vpn = site.vpn;
            data.latitude = site.latitude;
            data.longitude = site.longitude;
        }
        // data.vpn = site.vpn;
        // data.latitude = site.latitude;
        // data.longitude = site.longitude;
        }

        data.img = asset.img

       //Clean up data before Post
       data = Object.entries(data).reduce((a,[k,v]) => (v === null || v === '' ? a : {...a, [k]:v}), {})

    // console.log(data)
       API.post('asset', '/', {
           body: data,
           headers,
       })
       .then(response => {
        //    console.log(response)
            addToast('Asset Saved', { appearance: 'success', autoDismissTimeout: 8000 });
            setTimeout(() => window.location.reload(), 1400);
       }).catch(error => {
           console.log(error)
           addToast('Error Saving Asset', { appearance: 'error' });
       });
    }



    const handleDelete = async (id) => {
        setShowModal(false);

        // delete asset from user access list
        // const user_assets = await API.get('user_assets','/', params)
        // for (let i = 0; i < user_assets.length; i++) {
        //     API.post('user_assets', '/', {
        //         body: {
        //             id: user_assets[i].id,
        //             assets: user_assets[i].assets.filter(item => item !== id ),
        //             views: user_assets[i].views,
        //             settings: user_assets.settings
        //         },
        //         headers,
        //     }).then(res => {
        //         // console.log(res)
        //     }).catch(error => {
        //         // console.log(error)
        //     });;
        // }

        // delete asset
        API.del('asset', '/' + id, params)
        .then(res => {
            addToast('Asset Deleted', { appearance: 'success' });
            props.history.push('/devices');
        }).catch(error => {
            // console.log(error)
            addToast('Error Deleting Asset', { appearance: 'error' });
        });
    }
    
    const handleSite = (item) => {

        const selSite = sites.find(x => x.id === item)

        if (selSite){
            setSite({...selSite});
            asset.vpn = selSite.vpn;
            asset.latitude = selSite.latitude;
            asset.longitude = selSite.longitude;
        }else{
            setSite({
                id: '',
                address: '',
                country: '',
                location: '',
                vpn: '',
                latitude: 0,
                longitude: 0
            })
        }
    }

    const schema = yup.object().shape({
		name: yup.string()
            .required('Required'),
        serial_number: yup.string()
            .required('Required'),
        site_id: yup.string()
            .nullable()
            .required('Required'),
        // location: yup.string(),
            // .required('Required'),
        latitude: yup.number()
            .typeError("This is not a valid number"),
            // .required("Required"),
        longitude: yup.number()
            .typeError("This is not a valid number"),
            // .required("Required"),
        inst_date: yup.string(),
        expiry_date: yup.string(),
        email: yup.string().email('Invalid email'),
        });

	return (
    !isLoading ? (
    <Formik
    initialValues={asset}
    validationSchema={schema}
    onSubmit={ (values, { setSubmitting }) => {
        handleSubmit(values);
        setSubmitting(false);
    }}
    >
    {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
    <div className="DeviceDetail">
        <div className="col-md-12">
        <form key="form" onSubmit={handleSubmit}>
            <div className="row header">
                <div className="col-4">{asset.id ? 'Edit':'New'} Asset</div>
                <div className="col-4 d-flex align-items-end">
                {asset.last_update ?
                    <h5 className='text-secondary'>
                    data updated @&nbsp;
                    <Moment local format={formatDate[0] + " HH:mm:ss"} date={ asset.last_update } className={ moment(asset.last_update).isSameOrAfter(new Date(), "day") ? "text-secondary" : "text-danger" } />
                    </h5>
                :''}
                </div>
                <div className="col-4 d-flex justify-content-end">
                    <Button variant="secondary" className="mr-1 text-nowrap" onClick={()=>{props.history.goBack()}}>
                        Back &nbsp;
                        <FaAngleLeft />
                    </Button>
                    {(props.viewPermissions.find(i => i === 'edit_asset'))?
                    <Button variant="success" className="mr-1 text-nowrap" type="submit" >
                        Save &nbsp;
                        <FaSave />
                    </Button>
                    :''} 
                    {(props.viewPermissions.find(i => i === 'edit_asset') && site.vpn && asset.mqtt_chk)? 
                    <a href={'http://' + site.vpn + '/'} target='blank' className='btn btn-warning mr-1 text-nowrap p-2'>
                        Traffic Web UI &nbsp;
                        <FaArrowCircleRight />
                    </a>     
                    :''}
                                       
                    {(props.viewPermissions.find(i => i === 'delete_asset'))?
                    <Button variant="danger" className="mr-1 text-nowrap" type="button" onClick={handleShowModal} >
                        Delete &nbsp;
                        <FaTimes />
                    </Button>
                    :''}
                </div>
            </div>
            <div className="row div-content">
                <div className="col-md-12">
                    <Tabs defaultActiveKey="details" transition={false} id="asset_det">
                        <Tab eventKey="details" title="Details">
                        <TabContent className="p-3" >
                        <div className="row"> 
                            <div className="col-md-8"> 
                                
                        {/* ASSET DET START */}
                            <div className="row">
                            <div className="col-md-3 pb-3">
                            <Form.Group controlId="serial_number" className={touched.serial_number && errors.serial_number ? "has-error" : null}>
                                <Form.Label>ID / Serial Number</Form.Label>
                                <Form.Control
                                as="input"
                                value={values.serial_number}
                                onChange={handleChange}
                                disabled= {isAssetEdit ? true : false  }
                                />
                                {touched.serial_number && errors.serial_number ? <div className="error-message">{errors.serial_number}</div> : null}
                            </Form.Group>
                            </div>
                            <div className="col-md-6 pb-3">
                            <Form.Group controlId="name" className={touched.name && errors.name ? "has-error" : null}>
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                as="input"
                                value={values.name}
                                onChange={handleChange}
                                />
                                {touched.name && errors.name ? <div className="error-message">{errors.name}</div> : null}
                            </Form.Group>
                            </div>
                            <div className="col-md-3 pb-3">
                            <Form.Group controlId="status" className={touched.status && errors.status ? "has-error" : null}>
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={values.status}
                                    onChange={handleChange}
                                    disabled={props.user.administrator==='false'}>
                                        <option default value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                        <option value="removed">Removed</option>
                                </Form.Control>
                                {touched.status && errors.status ? <div className="error-message">{errors.status}</div> : null}
                            </Form.Group>
                            </div>

                            <div className="col-md-3 pb-3">
                            <Form.Group controlId="make" className={touched.make && errors.make ? "has-error" : null}>
                                <Form.Label>Make</Form.Label>
                                <Form.Control
                                as="input"
                                value={values.make}
                                onChange={handleChange}
                                />
                                {touched.make && errors.make ? <div className="error-message">{errors.make}</div> : null}
                            </Form.Group>
                            </div>

                            <div className="col-md-3 pb-3">
                            <Form.Group controlId="sim_card" className={touched.sim_card && errors.sim_card ? "has-error" : null}>
                                <Form.Label>SIM Card Number</Form.Label>
                                <Form.Control
                                as="input"
                                value={values.sim_card}
                                onChange={handleChange}
                                />
                                {touched.sim_card && errors.sim_card ? <div className="error-message">{errors.sim_card}</div> : null}
                            </Form.Group>
                            </div>
                            <div className="col-md-3 pb-3">
                            <Form.Group controlId="firmware" className={touched.firmware && errors.firmware ? "has-error" : null}>
                                <Form.Label>Firmware</Form.Label>
                                <Form.Control
                                as="input"
                                value={values.firmware}
                                onChange={handleChange}
                                />
                                {touched.firmware && errors.firmware ? <div className="error-message">{errors.firmware}</div> : null}
                            </Form.Group>
                            </div>

                            <div className='col-md-3'>
                            <Form.Group controlId="airscan_id" className={touched.airscan_id && errors.airscan_id ? "has-error" : null}>
                                <Form.Label>Airscan ID</Form.Label>
                                <Form.Control
                                as="input"
                                value={values.airscan_id}
                                onChange={handleChange}
                                />
                                {touched.airscan_id && errors.airscan_id ? <div className="error-message">{errors.airscan_id}</div> : null}
                            </Form.Group>

                            </div><br/>
                            <div className="col-md-3 pb-3">
                            <Form.Group>
                                <Form.Label htmlFor="inst_date"><FaCalendarAlt className="text-secondary" /> Installation Date</Form.Label>
                                <div>
                                <DatePicker
                                id="inst_date"
                                dateFormat={formatDate[1]}
                                selected={inst_date}
                                onChange={e => {
                                    setInst_date(e)
                                    setFieldValue('inst_date', e, false);
                                    }}
                                disabled={props.user.administrator==='false'}
                                className="form-control"/>
                                </div>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label htmlFor="expiry_date"><FaCalendarAlt className="text-secondary" /> Expiry Date</Form.Label>
                                <div>
                                <DatePicker
                                id="expiry_date"
                                dateFormat={formatDate[1]}
                                selected={expiry_date}
                                onChange={e => {
                                    setExp_date(e)
                                    setFieldValue('expiry_date', e, false);
                                    }}
                                className="form-control"/>
                                </div>
                            </Form.Group>                           
                            </div>
                            <div className="col-md-3 pb-3">
                            <Form.Group controlId="vpn" className={touched.vpn && errors.vpn ? "has-error" : null}>
                                <Form.Label>VPN</Form.Label>
                                <Form.Control
                                as="input"
                                value={values.vpn}
                                onChange={handleChange}
                                />
                                {touched.vpn && errors.vpn ? <div className="error-message">{errors.vpn}</div> : null}
                            </Form.Group>
                            <Form.Group controlId="speed" className={touched.speed && errors.speed ? "has-error" : null}>
                                <Form.Label>Speed</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={values.speed}
                                    onChange={handleChange}
                                    >
                                    <option default value="kph">km/h</option> {/* kilometers per hour */}
                                    <option value="ms">m/s</option> {/* metres per second => 1 m/s = 3.6 km/h */}
                                    <option value="mph">mph</option> {/* miles per hour => 1 mph = 1.60934 km/h */}
                                </Form.Control>
                                {touched.speed && errors.speed ? <div className="error-message">{errors.speed}</div> : null}
                            </Form.Group>
                            <Form.Check
                                type="checkbox"
                                id="mqtt_chk"
                                checked={values.mqtt_chk}
                                // onChange={handleChange}
                                onChange={(e)=>{
                                   setAsset({...asset, mqtt_chk: e.target.checked})
                                   setFieldValue('mqtt_chk', e.target.checked);
                                }}
                                label="MQTT"
                                />
                            </div>   
                            <div className="col-md-6 pb-3">
                            <Form.Group controlId="additional_info" className={touched.additional_info && errors.additional_info ? "has-error" : null}>
                                <Form.Label>Additional Information</Form.Label>
                                <Form.Control
                                as="textarea"
                                rows="3"
                                value={values.additional_info}
                                onChange={handleChange}
                                />
                                {touched.additional_info && errors.additional_info ? <div className="error-message">{errors.additional_info}</div> : null}
                            </Form.Group>
                            <Form.Group controlId="message" className={touched.message && errors.message ? "has-error" : null}>
                                <Form.Label>Public Message (Totem)</Form.Label>
                                <Form.Control
                                as="textarea"
                                rows="2"
                                value={values.message}
                                onChange={handleChange}
                                />
                                {touched.message && errors.message ? <div className="error-message">{errors.message}</div> : null}
                            </Form.Group>
                            </div>   
                      
                        </div>

                        </div>
        
                        {/* ASSET DET END */}
                            <div className="col-md-4 pb-3 border-left "> 
                                <div className="row py-2"> 
                                    <div className='col-12'>
                                        <h2>Site </h2>
                                    </div> 
                                </div>
                                <div className="row border-bottom bg-white border-top"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">site </div>
                                    <div className="col-md-8 py-2">
                                    <Form.Group controlId="site_id" className={touched.site_id && errors.site_id ? "has-error" : null}>
                                        <Form.Control
                                            as="select"
                                            value={values.site_id}
                                            onChange={e => {
                                                handleChange(e);
                                                handleSite(e.target.value)
                                                }}>
                                                <option key="siteId-0" value=""></option>
                                                {sites.map((item, i) => (
                                                <option key={"siteId-"+i} value={item.id}>{item.name}</option>
                                                ))}
                                        </Form.Control>
                                        {touched.site_id && errors.site_id ? <div className="error-message">{errors.site_id}</div> : null}
                                    </Form.Group>
                                    </div>
                                    <div className="col-md-1 px-0 py-2">
                                    {(values.site_id)?
                                    <Link to={'/site_det/'+ values.site_id }>
                                        <Button variant="info" size="sm">
                                            ...
                                        </Button>
                                    </Link>
                                    :''}
                                    </div>
                                </div>

                                <div className="row bg-white border-bottom"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">address</div>
                                    <div className="col-md-9 py-2">{site.address}</div>    
                                </div>  
                                <div className="row bg-white border-bottom"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">country</div>
                                    <div className="col-md-9 py-2">{site.country}</div>    
                                </div>   
                                <div className="row bg-white border-bottom"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">location</div>
                                    <div className="col-md-9 py-2">{site.location}</div>    
                                </div>  
                                <div className="row bg-white border-bottom"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">VPN</div>
                                    <div className="col-md-9 py-2">{site.vpn}
                                    </div>    
                                </div>  
                                <div className="row bg-white border-bottom"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">GPS</div>
                                    <div className="col-md-9 py-2">{site.latitude}, {site.longitude}</div>    
                                </div>   
                                <div className="row bg-white border-bottom"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">status</div>
                                    <div className={"col-md-9 py-2 small " + site.statusCss}><FaCircle/> { site.status }</div>
                                </div>  
                                <div className="row bg-white border-bottom"> 
                                    <div className="col-md-3 bg-light text-secondary py-2">Notes</div>
                                    <div className="col-md-9 py-2"><pre>{site.additional_info}</pre>
                                    {(site.vpn && asset.mqtt_chk)? 
                                        <div className='small p-1'>
                                            <span className='text-danger'>Important: </span>Make sure your VPN client is connected before opening WebUI
                                        </div>
                                    :''}
                                    </div>    
                                </div>  
                            </div>
                        </div>

                        {/* MAP */}
                        {isAssetEdit ? 
                            <div className="row">
                                <div className="col-2">
                                    <div className="row">
                                        <div className="col-md-12 text-secondary py-2">GPS coordinates</div>
                                    </div>
                                    <div className='row'>
                                        <Form.Group controlId="latitude" className={touched.latitude && errors.latitude ? "has-error" : null}>
                                            <Form.Label>Latitude</Form.Label>
                                            <Form.Control
                                                as="input"
                                                value={values.latitude}
                                                onChange={e => {
                                                    handleChange(e); // update Formik
                                                    setAsset({ ...asset, latitude: e.target.value }); // update asset state for map
                                                }}
                                            />
                                            {touched.latitude && errors.latitude ? <div className="error-message">{errors.latitude}</div> : null}
                                        </Form.Group>
                                    </div>
                                    <div className='row'>
                                        <Form.Group controlId="longitude" className={touched.longitude && errors.longitude ? "has-error" : null}>
                                            <Form.Label>Longitude</Form.Label>
                                            <Form.Control
                                                as="input"
                                                value={values.longitude}
                                                onChange={e => {
                                                    handleChange(e); // update Formik
                                                    setAsset({ ...asset, longitude: e.target.value }); // update asset state for map
                                                }}
                                            />
                                            {touched.longitude && errors.longitude ? <div className="error-message">{errors.longitude}</div> : null}
                                        </Form.Group>
                                    </div>
                                    <Button
                                        variant="primary"
                                        className="mr-1 text-nowrap"
                                        onClick={() => {
                                            setFieldValue('latitude', site.latitude);
                                            setFieldValue('longitude', site.longitude);
                                            restartGPS();
                                        }}
                                    >
                                        Restart GPS to Site
                                    </Button>

                                    <hr />

                                    <div className="row mt-3">
                                        <div className="col-md-12 text-secondary py-2">Facing direction</div>
                                    </div>
                                    <div className="row m-auto">
                                        <Form.Group controlId="rotation" className='w-100'>
                                            <Form.Label>Direction (0-360°)</Form.Label>
                                            <Form.Control
                                                type="range"
                                                min={0}
                                                max={360}
                                                value={sliderRotation}
                                                onChange={e => {
                                                    setSliderRotation(Number(e.target.value));
                                                }}
                                                onMouseUp={e => {
                                                    setAsset({ ...asset, rotation: sliderRotation });
                                                    setFieldValue('rotation', sliderRotation);
                                                }}
                                                onTouchEnd={e => {
                                                    setAsset({ ...asset, rotation: sliderRotation });
                                                    setFieldValue('rotation', sliderRotation);
                                                }}
                                            />
                                            <div>{sliderRotation}°</div>
                                            <div style={{width: '48px', height: '48px', margin: '0.5em auto'}}>
                                                <img
                                                    src={arrow_icon_url}
                                                    alt="arrow preview"
                                                    style={{
                                                        width: '48px',
                                                        height: '48px',
                                                        display: 'block',
                                                        margin: '0 auto',
                                                        transform: `rotate(${sliderRotation}deg)`,
                                                        transformOrigin: '50% 50%'
                                                    }}
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="col-10">
                                    {MemoMap}
                                    <img src={pin_green} alt="" height="16" width="16" />Asset 
                                    {SSAssets.length > 0 ? (<> | <img src={pin_yellow} alt="" height="16" width="16" />Same Site Assets</>) : ('')}
                                </div>
                            </div>
                        :''}

                        {/* SAME SITE ASSETS SSA - DETAILS LIST */}
                        {isAssetEdit ? 
                            <div className="row scroller m-auto pt-2" style={{ width: '94%' }}>
                                {(SSAssets.length > 0) ? (
                                    <>
                                    <div className="row">
                                        <div className="col-md-12 text-secondary py-2">Same Site Assets</div>
                                    </div>
                                
                                    {SSAssets.map((item, i) => (
                                        <div className="row border-bottom bg-white border-top w-100 selectableItem" onClick={() => {activateMapMarker(item.id)}} key={"ssa_" + i}> 

                                            <div className="col-md-1 bg-light text-secondary py-2">Asset</div>
                                            <div className="col-md-5 py-2">{item.name || '-'}</div>
                                                    
                                            <div className="col-md-1 bg-light text-secondary py-2">Country</div>
                                            <div className="col-md-1 py-2">{item.country}</div>

                                            <div className="col-md-1 bg-light text-secondary py-2">Location</div>
                                            <div className="col-md-1 py-2">{item.location}</div>

                                            <div className="col-md-1 bg-light text-secondary py-2">Status</div>
                                            <div className={"col-md-1 py-2 small " + item.statusCss}><FaCircle/> { item.status }</div>

                                        </div>
                                    ))}
                                    </>
                                ) : ('')}
                            </div>
                        :''}


                        </TabContent>
                        </Tab>
                        {(props.viewPermissions.find(i => i === 'edit_zones'))?
                        <Tab eventKey="zones" title="Zones">
                        <TabContent className="p-3" >
                            <div className="row">   
                            {[...Array(26)].map((item, i) =>
                            <div className="col-md-4 d-flex p-2" key={"zones_" + i}>
                                <div className='col-md-2 p-1'>Zone {i}</div>  
                                <div className='col-md-10 p-1'>                             
                                <Form.Control
                                    as="input"
                                    id={`zones.${i}.label`}
                                    value={values.zones[i].label}
                                    onChange={handleChange}
                                    // placeholder={"Zone " + i}
                                    type="text"
                                />  
                                </div>                             
                             </div>
                            )}
                            </div>
                        </TabContent>
                        </Tab>
                        :''}
                         {(props.viewPermissions.find(i => i === 'edit_relays'))?
                        <Tab eventKey="relays" title="Relays">
                        <TabContent className="p-3" >
                            <div className="row">  
                            {[...Array(16)].map((item, i) =>
                            <div className="col-md-4 d-flex p-2" key={"relays_" + i}>
                                <div className="col-md-2 p-1">Relay {i+1}</div>
                                <div className="col-md-10 p-1">
                                <Form.Control
                                    as="input"
                                    id={`relays.${i}.label`}
                                    value={values.relays[i].label}
                                    onChange={handleChange}
                                    // placeholder={["Relay ", i+1].join('')}
                                    type="text"
                                />
                                </div>
                            </div>
                            )}
                            </div>
                        </TabContent>
                        </Tab>
                        :''}

                        {(asset.mqtt_chk)?
                        <Tab eventKey="mqtt" title="MQTT">
                        <TabContent className="p-3" >
                            <div className="row p-1">
                                <div className="col-md-12">
                                    <Form.Group>
                                        <Form.Label>MQTT Server</Form.Label><br/>
                                        <strong>{values.mqtt.mqtt_server}</strong>
                                    </Form.Group>
                                </div>
                                <div className="col-md-12">
                                    <div className='row pb-3'>
                                        <div className="col-md-5">
                                            <Form.Group controlId='topic'>
                                                <Form.Label>Topic</Form.Label>
                                                <Form.Control
                                                as="input"
                                                value={values.topic}
                                                onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-2 d-flex align-items-center">
                                            <Button variant="warning" size="sm" onClick={()=>{
                                                if (asset.mqtt.topic === undefined || asset.mqtt.topic === '') asset.mqtt.topic = [];
                                                if (!asset.mqtt.topic.find(i => i===values.topic))
                                                    {
                                                        asset.mqtt.topic.push(values.topic)
                                                        asset.mqtt.subscribe=true;
                                                        setAsset({...asset});
                                                        values.topic=''
                                                    }
                                                }}
                                                >
                                                Subscribe <FaPlus/>
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="col-md-6 p-0">
                                        <ListGroup>
                                            {asset.mqtt.topic && asset.mqtt.topic.map((item, i) =>
                                                <ListGroup.Item key={"em"+i} className="d-flex justify-content-between align-items-start">
                                                    {asset.mqtt.topic[i]}
                                                    <Button variant="danger" size="sm" onClick={()=>setAsset({...asset, mqtt: { topic: asset.mqtt.topic.filter(item => item !== asset.mqtt.topic[i])}})}>
                                                        <FaTimes/>
                                                    </Button>
                                                </ListGroup.Item>
                                            )}
                                        </ListGroup>
                                    </div>
                                </div>
                            </div>
                        </TabContent>
                        </Tab>
                        :''}
                        {(props.viewPermissions.find(i => i === 'edit_notifications'))?
                        <Tab eventKey="notifications" title="Notifications">
                        <TabContent className="p-3" >
                            <div className="row">
                                <div className="col-md-12 p-3">
                                    <Form.Check
                                        type="checkbox"
                                        id="send_email"
                                        checked={values.send_email}
                                        // onChange={handleChange}
                                        onChange={(e)=>{
                                        setAsset({...asset, send_email: e.target.checked})
                                        setFieldValue('send_email', e.target.checked);
                                        }}
                                        label="Send Notification"
                                    />
                                </div>

                                <div className="col-md-12">
                                    <div className='row pb-3'>
                                        <div className="col-md-5">
                                            <Form.Group controlId='email' className={errors.email ? "has-error" : null}>
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control
                                                as="input"
                                                value={values.email}
                                                onChange={handleChange}
                                                type="email"
                                                />
                                                {errors.email ? <div className="error-message">{errors.email}</div> : null}
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-2 d-flex align-items-center">
                                            <Button variant="warning" size="sm" onClick={()=>{
                                                if (values.email!=='' &&
                                                    (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email))===false &&
                                                    !asset.emails.find(i => i===values.email))
                                                    {
                                                        setAsset({...asset, emails: [...asset.emails, values.email]});
                                                        values.email=''
                                                    }
                                                }}
                                                >
                                                Add <FaPlus/>
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="col-md-6 p-0">
                                        <ListGroup>
                                            {asset.emails.map((item, i) =>
                                                <ListGroup.Item key={"em"+i} className="d-flex justify-content-between align-items-start">
                                                    {asset.emails[i]}
                                                    <Button variant="danger" size="sm" onClick={()=>setAsset({...asset, emails: asset.emails.filter(item => item !== asset.emails[i])})}>
                                                        <FaTimes/>
                                                    </Button>
                                                </ListGroup.Item>
                                            )}
                                        </ListGroup>
                                    </div>
                                </div>
                            </div>
                        </TabContent>
                        </Tab>
                        :''}
                        {(isAssetEdit && props.viewPermissions.find(i => i === 'edit_asset'))?
                        <Tab eventKey="docs" title="Images">
                        <TabContent className="p-3" >
                            <DeviceDocs 
                                // asset={props.match.params.id} 
                                asset={asset}
                                setAsset={setAsset}
                                user={props.user}
                            />
                        </TabContent>
                        </Tab>
                        :''}
                        {(isAssetEdit && props.viewPermissions.find(i => i === 'view_user_list'))?
                        <Tab eventKey="users" title="Permissions">
                        <TabContent className="p-3" >
                            <DevicePerms 
                                asset={props.match.params.id} 
                                user={props.user}
                                userUpd={userUpd}
                                setUserUpd={setUserUpd}
                            />
                        </TabContent>
                        </Tab>
                        :''}
                    </Tabs>

                </div>
            </div>
            </form>
        </div>
        <Modal className="text-dark border-danger" show={showModal} onHide={handleCloseModal} animation={false} >
            <Modal.Header className="bg-danger text-light align-content-center" closeButton>
            <Modal.Title><h4><strong>Delete Asset</strong></h4></Modal.Title>
            </Modal.Header>
            <Modal.Body>Please confirm that you really want to delete this device</Modal.Body>
            <Modal.Footer>
            <Button className="m-0 mr-2" variant="danger" onClick={() => {handleDelete(props.match.params.id)}}>
                Delete
            </Button>
            <Button className="m-0"  variant="secondary" onClick={handleCloseModal}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

    </div>
    )}
    </Formik>
    ) : ''
    );
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
        viewPermissions: state.auth.viewPermissions,
    };
  };

export default connect(mapStateToProps)(DeviceDetail);
